<template>
<div class="financing_data">
  <!-- 融资轮次占比 -->
  <div class="chart_bg">
    <div class="title">
      <span class="chart_name">融资轮次占比 &nbsp;</span>
      <div class="condition">
        <div class="time_sel">
          <Dropdown @on-click="haddleChangeYQ">
            <a href="javascript:void(0)">{{params.count_type == '2' ? '季度' : '年度'}}</a>
            <DropdownMenu slot="list">
              <DropdownItem name="1" :disabled="params.count_type == '1'">年度</DropdownItem>
              <DropdownItem name="2" :disabled="params.count_type == '2'">季度</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="location">
          <AddressTab @selectAddress="addressChecked"></AddressTab>
        </div>
        <!-- <div class="upload">
          <a @click="downloadEcharts"><i class="iconfont">&#xe644;</i>下载</a>
        </div> -->
      </div>
    </div>

    <div class="chart" id="chart" :key="page_title + name"></div>
    <div class="time_slier">
      <Slider v-model="years" range :min="2011" :step="0.01" :tip-format="sliderTipFormat" :max="moment_year" @on-change="hadleTimeSlider" class="year_slider"></Slider>
      <div style="slier_axis" class="slier_axis">
        <span v-for="item,index in slier_axis" :key="item"  :style="'left:' + (100 / (slier_axis.length - 1)) * index + '%'">{{item}}</span>
      </div>
    </div>
    <p class="data_src"><span>数据来源：动脉橙数据库</span><span>数据截止时间：{{today}}</span></p>
  </div>
  <div class="top-tip">全部<span>（{{total}}）</span>
    <Dropdown @on-click="haddleChangeSort">
      <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
      <DropdownMenu slot="list">
        <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
  <div class="list_div">
    <Table :columns="columns" :data="list"></Table>
    <div class="page clear" v-if="total > 10">
      <Page :total="total" :page-size="10" :current="list_params.page" class="page_list" show-total show-elevator @on-change="handleChangePage" ref="pages" />
    </div>
  </div>
  <Contanct></Contanct>
  <DownloadCharts v-if="visible" :visible="visible" :imgbase="imgbase" :tabTitle="name" :params="params" @closeecharts="closeEcharts"></DownloadCharts>
  <Spin fix v-if="spinShow">
    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
    <div>Loading</div>
  </Spin>
</div>
</template>

<script>
import filter from 'js/filter'
import Contanct from '../Contanct'
import AddressTab from '../AddressTab'
import DownloadCharts from '../DownloadCharts'
import {
  financing_common
} from 'js/financing_mixins'
import echarts from 'echarts'
import {
  option4
} from 'js/financing_chart'
import {
  trendMapRound, trendOfEventList 
} from '../../../../service'
import moment from 'moment'

export default {
  mixins: [financing_common],
  components: {
    Contanct,
    AddressTab,
    DownloadCharts
  },
  computed: {
    map_round() {
      return this.$store.state.map_round
    }
  },
  data() {
    return {
      page_title: '投融资总趋势',
      name: '轮次分布',
      option: option4,
      list: [],
      list_params: {
        user_key: this.$store.state.user_key,
        page: 1,
        sort_type: 0,
        demostic: '',
        address_id: '',
        other_address: [],
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY')),
        round_ids: []
      },
      params: {
        user_key: this.$store.state.user_key,
        demostic: '',
        address_id: '',
        other_address: [],
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY')),
        count_type: 1
      }
    }
  },
  methods: {
    async getMap() {
      this.curInt = ''
      let res = await trendMapRound(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if (this.is_destroyed) {
          return false
        }
        // 图表数据
        let chart_data = res.res
        let s_data = {},
          total_even = [],
          quarter_arr = {},
          quarter_x = []

        if (this.params.count_type == 1) { // 按年

          this.time_axis.map(() => {
            total_even.push(0)
          })

          this.map_round.map((a) => {
            let arr_0 = []
            this.time_axis.map(() => {
              arr_0.push(0)
            })
            s_data[a] = arr_0
          })

          chart_data.map((a) => {
            let index = this.time_axis.findIndex((b) => b == a.e_time_year)
            if (index > -1) {
              total_even[index] += parseInt(a.total)
              for (var prop in s_data) {
                if (prop == a.round_name) {
                  s_data[prop][index] += parseInt(a.total)
                }
              }
            }
          })

          this.map_round.map((a, s) => {
            this.option.series[s].name = a
            let r_data = []
            s_data[a].map((b, i) => {
              r_data.push(Math.round(b / total_even[i] * 10000) / 100)
            })
            // console.log(s,r_data)
            this.option.series[s].data = r_data
          })

          this.time_axis.map(() => {
            this.option.series[8].data.push(100)
          })

          this.option.xAxis[0].data = this.time_axis
          this.option.xAxis[1].show = false
          this.option.grid.bottom = '10px'
          this.option.series[0].barWidth = 50
          // console.log('total_even',total_even)
          this.mychart.off('click')
          this.mychart.on('click', (params) => {
            this.loginVipFlow(() => {
              this.haddleClickChart1(params)
              this.mychart.setOption(this.option)
            })
          });
        } else {
          this.time_axis.map((a) => {
            quarter_arr[a] = {
              1: 0,
              2: 0,
              3: 0,
              4: 0
            }
            quarter_x.push('Q1')
            quarter_x.push('Q2')
            quarter_x.push('Q3')
            quarter_x.push('Q4')
          })

          this.map_round.map((a) => {
            s_data[a] = {}
          })

          for (var prop in s_data) {
            this.time_axis.map((a) => {
              s_data[prop][a] = {
                1: 0,
                2: 0,
                3: 0,
                4: 0
              }
            })
          }

          chart_data.map((a) => {
            // 一季度
            let index1 = this.time_axis.findIndex((b) => {
              return a.e_time_year == b && a.Q_num == 1
            })
            if (index1 > -1) {
              quarter_arr[a.e_time_year][1] += parseInt(a.total)
              for (prop in s_data) {
                if (prop == a.round_name) {
                  s_data[prop][a.e_time_year][1] += parseInt(a.total)
                }
              }
            }
            // 二季度
            let index2 = this.time_axis.findIndex((b) => {
              return a.e_time_year == b && a.Q_num == 2
            })
            if (index2 > -1) {
              quarter_arr[a.e_time_year][2] += parseInt(a.total)
              for (prop in s_data) {
                if (prop == a.round_name) {
                  s_data[prop][a.e_time_year][2] += parseInt(a.total)
                }
              }
            }
            // 三季度
            let index3 = this.time_axis.findIndex((b) => {
              return a.e_time_year == b && a.Q_num == 3
            })
            if (index3 > -1) {
              quarter_arr[a.e_time_year][3] += parseInt(a.total)
              for (prop in s_data) {
                if (prop == a.round_name) {
                  s_data[prop][a.e_time_year][3] += parseInt(a.total)
                }
              }
            }
            // 四季度
            let index4 = this.time_axis.findIndex((b) => {
              return a.e_time_year == b && a.Q_num == 4
            })
            if (index4 > -1) {
              quarter_arr[a.e_time_year][4] += parseInt(a.total)
              for (prop in s_data) {
                if (prop == a.round_name) {
                  s_data[prop][a.e_time_year][4] += parseInt(a.total)
                }
              }
            }
          })

          for (var prop in quarter_arr) {
            for (var item in quarter_arr[prop]) {
              total_even.push(quarter_arr[prop][item])
            }
          }

          let s_data2 = {}
          for (prop in s_data) {
            s_data2[prop] = []
            for (var item in s_data[prop]) {
              for (var item2 in s_data[prop][item]) {
                s_data2[prop].push(s_data[prop][item][item2])
              }
            }
          }

          this.map_round.map((a, s) => {
            this.option.series[s].name = a
            let r_data = []
            s_data2[a].map((b, i) => {
              r_data.push(Math.round(b / total_even[i] * 10000) / 100)
            })
            this.option.series[s].data = r_data
          })

          this.option.xAxis[0].data = quarter_x
          this.option.xAxis[1].show = true
          this.option.grid.bottom = '20px'
          this.option.series[0].barWidth = 18
          this.mychart.off('click')
        }

        this.option.legend.data = this.map_round
        this.option.xAxis[1].data = this.time_axis
        // 总数
        this.option.series[9].data = total_even
        this.option.xAxis[2].data = total_even
        this.echartChangeTheme5()
        this.mychart.setOption(this.option)
        this.spinShow = false

      } else {
        this.$Message.error(res.msg)
      }
    },
    async getList() {
      let res = await trendOfEventList(this.list_params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        // 列表数据
        this.$set(this.$data, 'list', res.res)
        if (this.list_params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
      } else {
        this.$Message.error(res.msg)
      }
    }
  },
  mounted() {
    const _this = this
    this.option.series[0].itemStyle.normal.color = function(params) {
      return params.dataIndex !== _this.curInt ? '#2F54EB' : '#233EB0'
    }
    this.option.series[1].itemStyle.normal.color = function(params) {
      return params.dataIndex !== _this.curInt ? '#40A9FF' : '#2F7EBF'
    }
    this.option.series[2].itemStyle.normal.color = function(params) {
      return params.dataIndex !== _this.curInt ? '#80DEEA' : '#5FA6AF'
    }
    this.option.series[3].itemStyle.normal.color = function(params) {
      return params.dataIndex !== _this.curInt ? '#1EA69C' : '#167C74'
    }
    this.option.series[4].itemStyle.normal.color = function(params) {
      return params.dataIndex !== _this.curInt ? '#FFCB6A' : '#BF984F'
    }
    this.option.series[5].itemStyle.normal.color = function(params) {
      return params.dataIndex !== _this.curInt ? '#F88C52' : '#B9683D'
    }
    this.option.series[6].itemStyle.normal.color = function(params) {
      return params.dataIndex !== _this.curInt ? '#E96350' : '#AE4A3B'
    }
    this.option.series[7].itemStyle.normal.color = function(params) {
      return params.dataIndex !== _this.curInt ? '#FFCCBC' : '#BF988C'
    }
    this.mychart = echarts.init(document.getElementById('chart'), 'macarons')
    this.getMap()
    this.getList()
  },
  destroyed() {
    this.option = ''
    this.mychart = ''
  },
  watch: {
    theme_switch(val) {
      if (!this.spinShow) {
        this.echartChangeTheme5()
        this.mychart.setOption(this.option, true)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/financing.stylus'
</style>
